import { CryptoStorage } from '@webcrypto/storage'

const encodeToSHA256 = async (id) => {
  const textAsBuffer = new TextEncoder().encode(id)
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', textAsBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const digest = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
  return digest
}

const startSafeStorage = async (id) => {
  const digest = await encodeToSHA256(`${id}`)
  return digest ? new CryptoStorage(digest) : {}
}

export const set = async (key, value) => {
  try {
    const storage = await startSafeStorage()

    await storage?.set(key, value)
  } catch (error) {
    console.error('error to set crypto store --', error)

    throw error
  }
}

export const get = async (key) => {
  try {
    const storage = await startSafeStorage()

    const response = await storage?.get(key)

    return response
  } catch (error) {
    console.error('error to get crypto store --', error)

    throw error
  }
}

export default {
  set,
  get,
}
